import { action, makeAutoObservable } from "mobx"
import {
    DeliveryConditions,
    MenuCategory,
    MenuItem,
    MenuItemModifierSet,
    MenuWithExtraData,
} from "../../../../services/menu/models";
import { AliasBinding } from "../../../../services/aliases/models";
import {TariffDetails} from '../../../../services/organizationBranches/models';

export enum MenuFormType {
    createMenu = "createMenu",
    editCategoriesForm = 'editCategoriesForm',
    editItemsOrdersForm = 'editItemsOrdersForm',
    editDeliveryConditions = 'editDeliveryConditions',
    editAlias = 'editAlias',
    showChecklist = 'showChecklist',
    updateChatForm = 'updateChatForm',
    tariffExpiresForm = 'tariffExpires'
}

export enum FormDisplayType {
    popup = "popup",
    inline = "inline"
}

class MenuFormsStore {
    forms: {
        [MenuFormType.tariffExpiresForm]: {
            open: boolean,
            type: FormDisplayType,
            current?: TariffDetails
        },
        [MenuFormType.createMenu]: {
            current?: MenuWithExtraData,
            type: FormDisplayType,
            open: boolean
        },

        [MenuFormType.editDeliveryConditions]:{
            current?: DeliveryConditions,
            updateDeliveryConditions: (deliveryConditions: DeliveryConditions) => void;
            type: FormDisplayType,
            open: boolean
        },
        [MenuFormType.editAlias]: {
            current?: AliasBinding,
            type: FormDisplayType,
            open: boolean,
            menuId?: number,
            notify?: () => void;
        },
        [MenuFormType.showChecklist]: {
            current?: MenuWithExtraData,
            type: FormDisplayType,
            open: boolean
        },
        [MenuFormType.updateChatForm]: {
            current?: MenuWithExtraData,
            type: FormDisplayType,
            open: boolean,
            menuId?: number,
            notify?: () => void;
        },
    } = {
        [MenuFormType.tariffExpiresForm]: {
            type: FormDisplayType.popup,
            open: false
        },
        [MenuFormType.createMenu]: {
            type: FormDisplayType.popup,
            open: false
        },

        [MenuFormType.editDeliveryConditions]:{
            updateDeliveryConditions: (deliveryConditions: DeliveryConditions) => {},
            type: FormDisplayType.popup,
            open: false
        },
        [MenuFormType.editAlias]: {
            type: FormDisplayType.popup,
            open: false,
        },
        [MenuFormType.showChecklist]: {
            type: FormDisplayType.popup,
            open: false,
        },
        [MenuFormType.updateChatForm]: {
            type: FormDisplayType.popup,
            open: false,
        },
    };

    constructor() {
        makeAutoObservable(this);
    }

    @action
    showPopupForm(type: MenuFormType, current?: any) {
        this.forms[type].open = true;
        this.forms[type].current = current;
        this.forms[type].type = FormDisplayType.popup;
    }

    @action
    closeForm(type: MenuFormType) {
        this.forms[type].open = false;
        this.forms[type].current = undefined;
    }


    @action
    setInitDeliveryConditions(deliveryConditions: (p: DeliveryConditions) => void){
        this.forms[MenuFormType.editDeliveryConditions].updateDeliveryConditions = deliveryConditions;
    }

    @action
    setMenuIdForEditAlias(menuId: number, notify: () => void){
        this.forms[MenuFormType.editAlias].menuId = menuId;
        this.forms[MenuFormType.editAlias].notify = notify;
    }

    @action
    setMenuIdForEditChats(menuId: number, notify: () => void){
        this.forms[MenuFormType.updateChatForm].menuId = menuId;
        this.forms[MenuFormType.updateChatForm].notify = notify;
    }

}

export default MenuFormsStore
